const LOCALHOST_HOSTNAMES = ['localhost', '127.0.0.1', '[::1]'];
const LOCAL_ADMIN_PORTAL_URL = 'http://localhost:3002';
const ADMIN_PORTAL_IMPERSONATING_PATH = '/impersonating';

export const getAdminPortalUrl = (): string => {
  const { hostname, host } = window.location;
  if (LOCALHOST_HOSTNAMES.includes(hostname)) {
    return LOCAL_ADMIN_PORTAL_URL;
  }
  return `https://admin.${host}`;
};

export const getAdminPortalImpersonationReturnUrl = (): string =>
  `${getAdminPortalUrl()}${ADMIN_PORTAL_IMPERSONATING_PATH}`;
